import passageInstruction from '../daze_passage_instructions.json';
import directionInstruction from '../daze_direction.json';
import clickOk from '../click_ok.json';
import scrollIntroInstruction from '../daze_scroll_intro.json';
import scrollDownInstruction from '../daze_scroll_down.json';
import scrollReadyInstruction from '../daze_ready.json';
import scrollInstruction from '../daze_ready_instructions.json';
import scrollReadyClickOk from '../daze_ready_click_ok.json';
import modelCorrectResponse from '../maze_model_correct_answer_selected.json';
import modelIncorrectResponse from '../maze_model_incorrect_answer_selected.json';
import modelSecondIncorrectResponse from '../maze_model_incorrect_answer_selected_twice.json';
import modelInstructionStart from '../maze_model_sentence_start.json';
import modelInstructionEnd from '../maze_model_sentence_end.json';
import modelOptionOne from '../maze_model_option_bus.json';
import modelOptionTwo from '../maze_model_option_pen.json';
import modelOptionThree from '../maze_model_option_work.json';
import practiceInstruction from '../daze_practice_avatar.json';
import practiceIntro from '../maze_practice_intro.json';
import practiceEnd from '../maze_practice_sentence_end.json';
import practiceOptionOne from '../maze_practice_option_afternoon.json';
import practiceOptionTwo from '../maze_practice_option_library.json';
import practiceOptionThree from '../maze_practice_option_morning.json';
import practiceCorrectAnswerSelected from '../maze_practice_correct_answer_selected.json';
import practiceIncorrectAnswerSelected from '../maze_practice_incorrect_answer_selected.json';
import practiceIncorrectAnswerSelectedTwice from '../maze_practice_incorrect_answer_selected_twice.json';

import passageInstructionAudio from '../../sounds/daze_passage_instructions.mp3';
import directionInstructionAudio from '../../sounds/daze_direction.mp3';
import clickOkAudio from '../../sounds/click_ok.mp3';
import scrollIntroInstructionAudio from '../../sounds/daze_scroll_intro.mp3';
import scrollDownInstructionAudio from '../../sounds/daze_scroll_down.mp3';
import scrollReadyInstructionAudio from '../../sounds/daze_ready.mp3';
import scrollInstructionAudio from '../../sounds/daze_ready_instructions.mp3';
import scrollReadyClickOkAudio from '../../sounds/daze_ready_click_ok.mp3';
import modelCorrectResponseAudio from '../../sounds/maze_model_correct_answer_selected.mp3';
import modelIncorrectResponseAudio from '../../sounds/maze_model_incorrect_answer_selected_twice.mp3';
import modelInstructionStartAudio from '../../sounds/maze_model_sentence_start.mp3';
import modelInstructionEndAudio from '../../sounds/maze_model_sentence_end.mp3';
import modelOptionOneAudio from '../../sounds/maze_model_option_bus.mp3';
import modelOptionTwoAudio from '../../sounds/maze_model_option_pen.mp3';
import modelOptionThreeAudio from '../../sounds/maze_model_option_work.mp3';
import practiceInstructionAudio from '../../sounds/daze_practice_avatar.mp3';
import practiceIntroAudio from '../../sounds/maze_practice_intro.mp3';
import practiceEndAudio from '../../sounds/maze_practice_sentence_end.mp3';
import practiceOptionOneAudio from '../../sounds/maze_practice_option_afternoon.mp3';
import practiceOptionTwoAudio from '../../sounds/maze_practice_option_library.mp3';
import practiceOptionThreeAudio from '../../sounds/maze_practice_option_morning.mp3';
import practiceCorrectAnswerSelectedAudio from '../../sounds/maze_practice_correct_answer_selected.mp3';
import practiceIncorrectAnswerSelectedAudio from '../../sounds/maze_practice_incorrect_answer_selected.mp3';
import practiceIncorrectAnswerSelectedTwiceAudio from '../../sounds/maze_practice_incorrect_answer_selected_twice.mp3';

const MAZE_CAPTIONS = {
    [passageInstructionAudio]: passageInstruction,
    [clickOkAudio]: clickOk,
    [directionInstructionAudio]: directionInstruction,
    [modelCorrectResponseAudio]: modelCorrectResponse,
    [modelIncorrectResponseAudio]: modelIncorrectResponse,
    [modelIncorrectResponseAudio]: modelSecondIncorrectResponse,
    [modelInstructionStartAudio]: modelInstructionStart,
    [modelInstructionEndAudio]: modelInstructionEnd,
    [modelOptionOneAudio]: modelOptionOne,
    [modelOptionTwoAudio]: modelOptionTwo,
    [modelOptionThreeAudio]: modelOptionThree,
    [practiceInstructionAudio]: practiceInstruction,
    [practiceIntroAudio]: practiceIntro,
    [practiceOptionOneAudio]: practiceOptionOne,
    [practiceOptionTwoAudio]: practiceOptionTwo,
    [practiceOptionThreeAudio]: practiceOptionThree,
    [practiceEndAudio]: practiceEnd,
    [practiceCorrectAnswerSelectedAudio]: practiceCorrectAnswerSelected,
    [practiceIncorrectAnswerSelectedAudio]: practiceIncorrectAnswerSelected,
    [practiceIncorrectAnswerSelectedTwiceAudio]: practiceIncorrectAnswerSelectedTwice,
    [clickOkAudio]: clickOk,
    [scrollIntroInstructionAudio]: scrollIntroInstruction,
    [scrollReadyInstructionAudio]: scrollReadyInstruction,
    [scrollInstructionAudio]: scrollInstruction,
    [scrollDownInstructionAudio]: scrollDownInstruction,
    [scrollReadyClickOkAudio]: scrollReadyClickOk,
    [clickOkAudio]: clickOk,
};

export default MAZE_CAPTIONS;
